"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const graphql_tag_1 = tslib_1.__importDefault(require("graphql-tag"));
const components_1 = require("@apollo/client/react/components");
const query = (0, graphql_tag_1.default) `
  query getParams($name: ID) {
    params(name: $name, mutation: true) {
      name
      result
      basicResultQuery
      params
    }
  }
`;
class WithParams extends react_1.default.Component {
    render() {
        return (react_1.default.createElement(components_1.Query, { query: query, variables: { name: this.props.name }, client: this.props.client }, (result) => {
            const { error, data } = result;
            if (data && data.params) {
                return this.props.children(data.params);
            }
            if (error) {
                console.error('Error fetching autoform information');
                console.error(error);
                return null;
            }
            if (this.props.loading)
                return this.props.loading;
            return null;
        }));
    }
}
exports.default = WithParams;
//# sourceMappingURL=index.js.map